
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/river-pro-portable-power-station",
      function () {
        return require("private-next-pages/river-pro-portable-power-station/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/river-pro-portable-power-station"])
      });
    }
  